import { render, staticRenderFns } from "./UserVerified.vue?vue&type=template&id=6b4a1fd8&scoped=true&"
import script from "./UserVerified.vue?vue&type=script&lang=js&"
export * from "./UserVerified.vue?vue&type=script&lang=js&"
import style0 from "./UserVerified.vue?vue&type=style&index=0&id=6b4a1fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4a1fd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
